export default __webpack_public_path__ + "static/media/signup.f9a177d7.png";